import { ArticlePreview } from '@/types/article';
import { CategoryLabelVariant } from '../CategoryLabel/CategoryLabel';

export enum ArticleCardVariant {
  Default = 'default',
  TwoColumn = 'twoColumn',
}

export interface ArticleCardInput {
  article: ArticlePreview;
  variant?: ArticleCardVariant;
  className?: string;
  tagVariant?: CategoryLabelVariant;
}
